import React, { useState, useEffect } from 'react';
import { authEventManager } from 'src/lib/api/authEventManager';
import { refreshToken, logout } from 'src/lib/api/auth/auth.api'; // We will create this next
import { useToast } from 'src/lib/toast-context';
import { useAuth } from 'src/hooks/auth/useAuth';

// Basic Modal styles (replace with your UI library e.g., Material-UI, Chakra, etc.)
const modalStyles: React.CSSProperties = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    padding: '2rem',
    zIndex: 1000,
    border: '1px solid #ccc',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
};

const overlayStyles: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 999,
};

export const SessionExpiredModal = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isRefreshing, setIsRefreshing] = useState(false);
    const { showToast } = useToast();

    useEffect(() => {
        const handleAuthError = () => {
            setIsOpen(true);
        };

        // Listen for the event from the Axios interceptor
        authEventManager.on('auth-error', handleAuthError);

        return () => {
            // Clean up the listener
            authEventManager.off('auth-error', handleAuthError);
        };
    }, []);

    const handleLogout = () => {
        logout(); // This will clear storage and redirect
        setIsOpen(false);
        // Signal to the interceptor to cancel any pending requests
        authEventManager.emit('logout');
    };

    if (!isOpen) {
        return null;
    }

    return (
        <>
            <div style={overlayStyles} />
            <div style={modalStyles}>
                <h2>Session Expired</h2>
                <p>Your session has expired. You can try to refresh it or log in again.</p>
                <div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
                    <button onClick={handleLogout} disabled={isRefreshing}>
                        Login Again
                    </button>
                    <button onClick={()=>{
                        authEventManager.emit("auth-refresh")
                    }} disabled={isRefreshing}>
                        {isRefreshing ? 'Refreshing...' : 'Refresh Session'}
                    </button>
                </div>
            </div>
        </>
    );
};